module.exports = __webpack_public_path__ + "img/copy.a80292a6.svg";